import React from 'react'

const products = [
  {
    name: 'Space Coffee',
    subtitle: 'Amino-Kaffee auf Kokos-Basis',
    desc: 'Kaffee auf Kokosbasis mit Aminosäuren, Taurin & L-Carnitin — eine komplett neue Kategorie. Laktosefrei, sauberer Geschmack.',
    price: '19,95 €',
    asin: 'B0H3HP4X3Z',
  },
  {
    name: 'Space Nitro',
    subtitle: 'Pre-Workout · Heavy-Duty',
    desc: '6.000 mg L-Citrullin, 4.420 mg L-Arginin AKG, 2.000 mg Tri-Creatine Citrate — maximale Pump-Formel ohne Kompromisse.',
    price: '24,95 €',
    asin: 'B0H8LKZ51C',
  },
  {
    name: 'Space Electro Rage',
    subtitle: 'Pre-Workout · Full-Session',
    desc: '5.000 mg L-Citrullin-DL-Malat, Kokoswasser & Rote-Bete-Pulver — anhaltende Energie und Pump ohne Crash, bis zum letzten Rep.',
    price: '24,95 €',
    asin: 'B0H3HR1QBY',
  },
]

const ShopSection = () => {
  return (
    <div id='shop' className='w-full bg-black py-[6rem] px-4'>

      {/* Header */}
      <div className='max-w-[1240px] mx-auto text-center mb-16'>
        <p style={{color:'#cc2200'}} className='font-bold tracking-[4px] uppercase text-sm mb-3'>
          Jetzt auf Amazon
        </p>
        <h2 className='text-white md:text-5xl sm:text-4xl text-3xl font-bold mb-6'>
          Unsere eigene Supplement-Linie
        </h2>
        <p className='text-gray-400 md:text-xl text-lg max-w-2xl mx-auto'>
          Im SpacePowerGym entwickelt, täglich von unseren Athleten genutzt —
          SpacePower-Supplements für echte Gym-Performance, bequem über Amazon bestellt.
        </p>
      </div>

      {/* Product Cards */}
      <div className='max-w-[1240px] mx-auto grid md:grid-cols-3 gap-8 mb-16'>
        {products.map((p) => (
          <a
            key={p.asin}
            href={`https://www.amazon.de/dp/${p.asin}`}
            target='_blank'
            rel='noopener noreferrer'
            className='block bg-[#0d0d0d] border border-gray-800 rounded-2xl p-8 transition-all cursor-pointer'
            style={{}}
            onMouseEnter={e => e.currentTarget.style.borderColor = '#cc2200'}
            onMouseLeave={e => e.currentTarget.style.borderColor = ''}
          >
            <h3 className='text-white text-2xl font-bold mb-1'>{p.name}</h3>
            <p style={{color:'#cc2200'}} className='font-semibold text-sm mb-3 uppercase tracking-wide'>{p.subtitle}</p>
            <p className='text-gray-400 text-sm leading-relaxed mb-6'>{p.desc}</p>
            <div className='flex items-center justify-between'>
              <span className='text-white text-xl font-bold'>{p.price}</span>
              <span style={{background:'#cc2200'}} className='text-white text-sm font-bold px-4 py-2 rounded-lg'>
                Zum Produkt
              </span>
            </div>
          </a>
        ))}
      </div>

      {/* Big CTA Banner */}
      <div className='max-w-[1240px] mx-auto'>
        <div className='rounded-2xl p-12 text-center border' style={{background:'rgba(204,34,0,0.07)', borderColor:'rgba(204,34,0,0.3)'}}>
          <p style={{color:'#cc2200'}} className='font-bold tracking-widest uppercase text-sm mb-4'>
            SpacePowerGym x SpacePower.Store
          </p>
          <h3 className='text-white md:text-4xl text-2xl font-bold mb-4'>
            Gym-Mitglied? Dann kennst du unsere Supplements.
          </h3>
          <p className='text-gray-400 md:text-lg mb-8 max-w-xl mx-auto'>
            Alle SpacePower-Supplements sind direkt im Gym erhältlich — oder bequem über Amazon.de
            nach Hause bestellen.
          </p>
          <a
            href='https://spacepower.store'
            target='_blank'
            rel='noopener noreferrer'
            className='inline-block text-white font-bold text-lg px-10 py-4 rounded-xl transition-opacity duration-200 hover:opacity-90'
            style={{background:'#cc2200'}}
          >
            Alle Produkte ansehen
          </a>
        </div>
      </div>

    </div>
  )
}

export default ShopSection
